import * as Storage from '../utils/local-storage';
import JwtDecode from 'jwt-decode';
import { CheckInvitation, CheckSession, CreateSession } from '../connection/app-entry';
import { LoadMeeting } from '../connection/meeting';

export default function HandleInvitation(token: string, invitation: string) {
	return new Promise(async (resolve, reject) => {
		try {
			const invited = await CheckInvitation(token, invitation);
			if (!invited) {
				return reject("BAD_INVITE");
			}

			const meeting = await LoadMeeting(token, invited.meeting);
			resolve(meeting);
		} catch (e) {
			console.error(e);
			reject(e);
		}
	})
}